export const intervalWhile = <T>(
  condition: () => boolean,
  action: () => T,
  deltaMilliseconds = 50, // 50 * 100 = 2500 = 2.5 seconds
  maxRetryCount = 50,
): Promise<T> => {
  return new Promise((resolve, reject) => {
    let currentRetryCount = 0

    const interval = setInterval(() => {
      currentRetryCount++
      if (condition()) {
        try {
          resolve(action())
        } catch (error) {
          reject(error)
        } finally {
          clearInterval(interval)
        }
      } else if (currentRetryCount >= maxRetryCount) {
        clearInterval(interval)
      }
    }, deltaMilliseconds)
  })
}
